/* Shared storefront primitives: money, safe saved state and customer events. */
(function () {
  var config = window.WFT || {};
  window.wftInitialVariant = new URL(location.href).searchParams.has('variant');
  window.wftMoney = function (cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: config.currency || 'USD'
    }).format((Number(cents) || 0) / 100);
  };
  window.wftParseMoney = function (value) {
    var parts = new Intl.NumberFormat(document.documentElement.lang || 'en').formatToParts(1234.5);
    var group = (parts.find(function (p) { return p.type === 'group'; }) || {}).value;
    var decimal = (parts.find(function (p) { return p.type === 'decimal'; }) || {}).value || '.';
    var text = String(value); if (group) text = text.split(group).join('');
    return parseFloat(text.replace(decimal, '.').replace(/[^0-9.\-]/g, ''));
  };
  window.wftSetResponsiveImage = function (image, source) {
    var url = new URL(source, location.href);
    var candidates = [200,320,400,460,600,700,800,1000].map(function (width) { var candidate = new URL(url.href); candidate.searchParams.set('width',width); return candidate.href + ' ' + width + 'w'; }).join(', ');
    if (image.classList.contains('alt') && !image.dataset.hoverLoaded) {
      image.removeAttribute('src'); image.removeAttribute('srcset');
      image.dataset.srcset = candidates; image.dataset.src = url.href;
    } else { image.srcset = candidates; image.src = url.href; }
  };
  window.wftRoute = function (path) { return (config.rootUrl || '/').replace(/\/$/, '') + '/' + path.replace(/^\//, ''); };
  window.wftEscape = function (text) { return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) { return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); };
  window.wftStorage = {
    get: function (key, fallback) { try { var value = JSON.parse(localStorage.getItem(key)); return value == null ? fallback : value; } catch (e) { return fallback; } },
    set: function (key, value) { try { localStorage.setItem(key, JSON.stringify(value)); return true; } catch (e) { return false; } }
  };
  // Custom interaction events only. Shopify's sales-channel pixels own the
  // standard ecommerce events and server-side Purchase deduplication.
  var privacyLoading = false;
  function ensurePrivacy() {
    var shopify = window.Shopify;
    if (!shopify || shopify.customerPrivacy || privacyLoading || typeof shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    try {
      shopify.loadFeatures([{name:'consent-tracking-api', version:'0.1'}], function () { privacyLoading = false; });
    } catch (e) { privacyLoading = false; }
  }
  ensurePrivacy();
  document.addEventListener('DOMContentLoaded', ensurePrivacy);
  window.wftTrack = function (name, data) {
    try {
      ensurePrivacy();
      var shopify = window.Shopify, privacy = shopify && shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' || !privacy.analyticsProcessingAllowed()) return;
      if (shopify.analytics && typeof shopify.analytics.publish === 'function') {
        var result = shopify.analytics.publish('wft_' + name, Object.assign({
          currency: config.currency || 'USD',
          buying_mode: document.querySelector('.goods.bulk') ? 'bulk' : 'grid'
        }, data || {}));
        if (result && typeof result.catch === 'function') result.catch(function () {});
      }
    } catch (e) { /* Analytics must never block shopping or bypass consent. */ }
  };
})();
(function () {
  document.querySelectorAll('[data-country]').forEach(function (country) {
    var province = document.getElementById(country.dataset.provinceId);
    if (!province) return;
    if (country.dataset.default) country.value = country.dataset.default;
    function update(initial) {
      var option = country.options[country.selectedIndex], regions = [];
      try { regions = JSON.parse(option.getAttribute('data-provinces') || '[]'); } catch (e) {}
      province.replaceChildren();
      regions.forEach(function (entry) { province.add(new Option(entry[1], entry[0])); });
      province.parentElement.hidden = !regions.length;
      province.disabled = !regions.length;
      if (initial && province.dataset.default) province.value = province.dataset.default;
    }
    country.addEventListener('change', function () { update(false); }); update(true);
  });
  document.querySelectorAll('[data-delete-address]').forEach(function (form) { form.addEventListener('submit', function (e) { if (!confirm('Delete this address?')) e.preventDefault(); }); });
  var recover = document.getElementById('recover');
  if (recover && (location.hash === '#recover' || recover.querySelector('.errors,[role="status"]'))) recover.open = true;
})();
(function () {
  var KEY = 'wft_recent_searches';
  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var field = form.querySelector('[name="q"]'); if (!field || !field.value.trim()) return;
      var term = field.value.trim().slice(0, 160);
      var recent = wftStorage.get(KEY, []); if (!Array.isArray(recent)) recent = [];
      wftStorage.set(KEY, [term].concat(recent.filter(function (s) { return s !== term; })).slice(0, 5));
      // Do not send free-text searches (which can contain personal data) to pixels.
      wftTrack('search_submitted', {query_length:term.length});
    });
  });
  document.querySelectorAll('[data-recent-searches]').forEach(function (host) {
    var recent = wftStorage.get(KEY, []); if (!Array.isArray(recent)) return;
    recent.forEach(function (term) { var a = document.createElement('a'); a.textContent = term; a.href = wftRoute('search') + '?type=product,page,article&options%5Bunavailable_products%5D=last&q=' + encodeURIComponent(term); host.querySelector('div').appendChild(a); });
    host.hidden = !recent.length;
  });
  var count = document.querySelector('[data-search-count]');
  if (count) wftTrack(Number(count.dataset.searchCount) ? 'search_results' : 'search_zero_results', {result_count:Number(count.dataset.searchCount)});
  var host = document.querySelector('[data-search-collections]');
  if (host && host.dataset.query) {
    fetch(window.WFT.predictiveUrl + '.json?q=' + encodeURIComponent(host.dataset.query) + '&resources[type]=collection&resources[limit]=8')
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); }).then(function (data) {
        var items = data.resources.results.collections || [];
        items.forEach(function (item) { var link = document.createElement('a'); link.href = item.url; link.textContent = item.title; host.querySelector('div').appendChild(link); }); host.hidden = !items.length;
      }).catch(function () {});
  }
  var exact = document.querySelector('[data-exact-sku]');
  if (exact && exact.dataset.query && /^[\w .\-()/]+$/.test(exact.dataset.query)) {
    fetch(wftRoute('search') + '?view=sku&type=product&options%5Bunavailable_products%5D=show&q=' + encodeURIComponent('variants.sku:"' + exact.dataset.query + '"'))
      .then(function (r) { if (!r.ok) throw new Error(); return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[data-sku-match]').forEach(function (link) {
          if (link.dataset.skuMatch.toLowerCase() === exact.dataset.query.toLowerCase()) exact.querySelector('div').appendChild(link);
        }); exact.hidden = !exact.querySelector('a');
      }).catch(function () {});
  }
})();
(function () {
  document.querySelectorAll('#colourRow label,.packcard[role="button"]').forEach(function (control) {
    control.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); control.click(); }
      if (['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)) {
        e.preventDefault(); var siblings = Array.from(control.parentElement.children).filter(function (el) { return el.matches('[role="button"]') && !el.hidden; });
        var delta = e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1;
        var next = siblings[(siblings.indexOf(control) + delta + siblings.length) % siblings.length]; if (next) { next.focus(); next.click(); }
      }
    });
    new MutationObserver(function () { control.setAttribute('aria-pressed', String(control.classList.contains('on'))); }).observe(control, {attributes:true, attributeFilter:['class']});
  });
  document.querySelectorAll('[data-product-media]').forEach(function (template) {
    var details = template.closest('details'), player = details.querySelector('.media-player');
    details.addEventListener('toggle', function () {
      if (details.open && !player.children.length) {
        player.appendChild(template.content.cloneNode(true));
        var model = player.querySelector('model-viewer');
        if (model && window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0',onLoad:function () { if (Shopify.ModelViewerUI) new Shopify.ModelViewerUI(model); }}]);
      } else if (!details.open) { player.replaceChildren(); }
    });
  });
})();
// Shared modal behavior for cart, saved styles, filters and newsletter.
(function () {
  var active = null, opener = null, isolated = [], previousOverflow = '', lastOutside = null;
  var selector = '#cartDrawer,#saveDrawer,#filterRail,#epop';
  // The filter rail uses a class in older templates.
  var panels = Array.from(new Set(Array.from(document.querySelectorAll(selector + ',.rail'))));
  function shown(panel) { return panel.id === 'epop' ? !panel.hidden : panel.classList.contains('open'); }
  function focusables(panel) { return Array.from(panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"],summary')).filter(function (el) { return !el.disabled && !el.hidden && el.getClientRects().length && !el.closest('[inert]'); }); }
  function restore() { isolated.forEach(function (pair) { pair[0].inert = pair[1]; }); isolated = []; }
  function sync() {
    var next = panels.filter(shown).pop() || null;
    if (next === active) return;
    var old = active;
    restore();
    if (!old && next) { opener = lastOutside || document.activeElement; previousOverflow = document.documentElement.style.overflow; }
    active = next;
    panels.forEach(function (panel) { var visible = shown(panel) || (panel.classList.contains('rail') && matchMedia('(min-width:901px)').matches); panel.inert = !visible; panel.setAttribute('aria-hidden', String(!visible)); if (panel !== active) { panel.removeAttribute('aria-modal'); if (panel.classList.contains('rail')) panel.removeAttribute('role'); } });
    if (!active) { document.documentElement.style.overflow = previousOverflow; if (opener && opener.isConnected) opener.focus({preventScroll:true}); return; }
    active.inert = false; active.setAttribute('role', 'dialog'); active.setAttribute('aria-modal', 'true');
    if (!active.hasAttribute('aria-label') && !active.hasAttribute('aria-labelledby')) active.setAttribute('aria-label', active.classList.contains('rail') ? 'Filters and view' : 'Shopping dialog');
    var branch = active;
    while (branch.parentElement) {
      Array.from(branch.parentElement.children).forEach(function (el) { if (el !== branch && !el.matches('script,style,.cartscrim,.savescrim,.epscrim,.railscrim')) { isolated.push([el,el.inert]); el.inert = true; } });
      branch = branch.parentElement; if (branch === document.body) break;
    }
    document.documentElement.style.overflow = 'hidden';
    var first = focusables(active)[0]; if (first) first.focus({preventScroll:true}); else { active.tabIndex = -1; active.focus(); }
  }
  panels.forEach(function (panel) { new MutationObserver(sync).observe(panel, {attributes:true,attributeFilter:['class','hidden']}); });
  document.addEventListener('focusin', function (e) { if (!active && !panels.some(function (panel) { return panel.contains(e.target); })) lastOutside = e.target; });
  document.addEventListener('keydown', function (e) {
    if (!active || e.key !== 'Tab') return;
    var items = focusables(active), first = items[0], last = items[items.length - 1];
    if (!first) { e.preventDefault(); return; }
    if (e.shiftKey && (document.activeElement === first || !active.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && (document.activeElement === last || !active.contains(document.activeElement))) { e.preventDefault(); first.focus(); }
  });
  // Closed off-canvas drawers must not be keyboard or screen-reader targets.
  panels.forEach(function (panel) { if (!shown(panel) && !(panel.classList.contains('rail') && matchMedia('(min-width:901px)').matches)) { panel.inert = true; panel.setAttribute('aria-hidden','true'); } });
  sync();
})();

// A single sticky control mirrors the original product form without a second ID field.
(function () {
  var form = document.getElementById('AddForm'), add = document.getElementById('addBtn'), qty = document.getElementById('qty');
  if (!form || !add || !qty) return;
  var bar = document.createElement('div'); bar.className = 'sticky-buy'; bar.hidden = true;
  var summary = document.createElement('span'), input = document.createElement('input'), button = document.createElement('button');
  input.type='number'; input.min='1'; input.setAttribute('aria-label','Packs'); button.type='button'; button.className='btn';
  var stepper = document.createElement('div'), minus = document.createElement('button'), plus = document.createElement('button');
  stepper.className = 'sticky-qty';
  minus.type = plus.type = 'button'; minus.textContent = '−'; plus.textContent = '+';
  minus.setAttribute('aria-label','Remove one pack'); plus.setAttribute('aria-label','Add one pack');
  input.inputMode = 'numeric';
  stepper.append(minus,input,plus);
  bar.append(summary,stepper,button); document.body.appendChild(bar);
  function paint() {
    var pack = document.querySelector('.packcard.on');
    summary.textContent = pack ? (pack.dataset.title || pack.dataset.c || '') : 'Choose a pack';
    input.value = qty.value; if (qty.max) input.max=qty.max; else input.removeAttribute('max');
    button.textContent = form.dataset.addBusy === '1' ? 'Adding…' : add.disabled ? 'Unavailable' : 'Add · ' + wftMoney(Number(pack && pack.dataset.price) * Number(qty.value) * 100);
    button.disabled = add.disabled; input.disabled = add.disabled;
    minus.disabled = add.disabled || Number(qty.value) <= 1;
    plus.disabled = add.disabled || (!!qty.max && Number(qty.value) >= Number(qty.max));
  }
  [minus,plus].forEach(function (control, index) { control.addEventListener('click',function () {
    qty.value = Math.max(1, Math.min(Number(qty.max) || Infinity, Number(qty.value) + (index ? 1 : -1)));
    qty.dispatchEvent(new Event('change',{bubbles:true})); paint();
  }); });
  input.addEventListener('change',function () { qty.value=input.value; qty.dispatchEvent(new Event('change',{bubbles:true})); paint(); });
  button.addEventListener('click',function () { if (!input.checkValidity()) {input.reportValidity(); return;} form.requestSubmit(add); });
  new MutationObserver(paint).observe(add,{attributes:true,childList:true,subtree:true,attributeFilter:['disabled']});
  qty.addEventListener('change',paint); document.addEventListener('wft:variant',paint);document.addEventListener('wft:quantity',paint);
  new IntersectionObserver(function (entries) { bar.hidden=entries[0].isIntersecting || entries[0].boundingClientRect.top > 0; },{threshold:0}).observe(add);
  paint();
})();

// Image candidates follow column width without repeated writes or detached observers.
(function () {
  var tracked = new WeakSet();
  var observer = new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      var width=Math.ceil(entry.contentRect.width);
      if (width>0) entry.target.querySelectorAll('img[srcset]').forEach(function (img) {
        var size=width+'px';if(img.sizes!==size)img.sizes=size;
      });
    });
  });
  function figures(root) {
    var found=Array.from(root.querySelectorAll('.card figure'));
    if(root.matches && root.matches('figure'))found.unshift(root);
    return found;
  }
  function bind(root) { figures(root).forEach(function (figure) {
    if(!figure.closest('.card') || tracked.has(figure))return;tracked.add(figure);observer.observe(figure);
  }); }
  bind(document);
  new MutationObserver(function (changes) {
    var added=new Set(),removed=new Set();
    changes.forEach(function(change){
      change.addedNodes.forEach(function(node){if(node.nodeType===1 && (node.matches('figure,.card') || node.querySelector('.card,figure')))added.add(node);});
      change.removedNodes.forEach(function(node){if(node.nodeType===1)removed.add(node);});
    });
    added.forEach(function(node){if(node.isConnected)bind(node);});
    removed.forEach(function(node){if(!node.isConnected)figures(node).forEach(function(figure){observer.unobserve(figure);tracked.delete(figure);});});
  }).observe(document.getElementById('MainContent') || document.body,{childList:true,subtree:true});
})();
// Remember shopping choices, but never overwrite a shared ?variant= selection.
document.addEventListener('DOMContentLoaded', function () {
  var KEY='wft_browsing_v1', state;
  try { state=JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch(e) { state={}; }
  if (!state.choices || typeof state.choices!=='object') state.choices={};
  function save() { try { sessionStorage.setItem(KEY,JSON.stringify(state)); } catch(e) {} }
  var restoring=true;
  var pageKey=location.pathname+location.search;
  if(!state.pages || typeof state.pages!=='object')state.pages={};
  document.addEventListener('wft:page-loaded',function(e){var pages=state.pages[pageKey] || [];if(!pages.includes(e.detail.url))pages.push(e.detail.url);state.pages[pageKey]=pages.slice(0,20);save();});
  function restoreCards(root) {
    root.querySelectorAll('.card[data-product-id]:not([data-resurfaced])').forEach(function (card) {
      var choice=state.choices[card.dataset.productId]; if(!choice || !card.wftSelect) return;
      var run=Array.from(card.querySelectorAll('.qarun')).find(function (r) { return r.dataset.vid===choice.vid; });
      if(run) { card.querySelector('[name="quantity"]').value=choice.qty;card.wftSelect(run); }
    });
  }
  restoreCards(document); restoring=false;
  document.addEventListener('wft:cards',function(e){restoring=true;restoreCards(e.detail.root);restoring=false;});
  document.addEventListener('wft:card-selection',function(e){if(restoring)return;var card=e.target;if(card.hasAttribute('data-resurfaced'))return;state.choices[card.dataset.productId]={vid:card.dataset.vid,qty:card.querySelector('[name="quantity"]').value};save();});
  var pdp=document.querySelector('[data-pdp]'),qty=document.getElementById('qty');
  if(pdp && qty){
    var choice=state.choices[pdp.dataset.productId];
    if(choice){var run=Array.from(document.querySelectorAll('.packcard')).find(function(r){return r.dataset.vid===choice.vid && r.dataset.oos!=='1' && !r.classList.contains('off');});
      if(run && !window.wftInitialVariant){var swatch=Array.from(document.querySelectorAll('#colourRow label')).find(function(s){return s.dataset.c===run.dataset.c;});if(swatch)swatch.click();run.click();}
      // Liquid has already respected explicit variant URLs; only quantity is restored for that variant.
      var selected=document.getElementById('variantId');
      if(selected && selected.value===choice.vid){qty.value=choice.qty;qty.dispatchEvent(new Event('change',{bubbles:true}));}
    }
    function remember(){var id=document.getElementById('variantId');state.choices[pdp.dataset.productId]={vid:id.value,qty:qty.value};save();}
    document.addEventListener('wft:variant',remember);document.addEventListener('wft:quantity',remember);qty.addEventListener('change',remember);
    if(state.collection){var url=new URL(state.collection,location.origin);if(url.origin===location.origin){var back=document.createElement('a');back.href=url.href;back.textContent='Return to your collection';back.className='return-collection';var row=pdp.querySelector('.product-breadcrumb-row');if(row)row.appendChild(back);else pdp.querySelector('.crumb').after(back);}}
  }
  if(document.body.classList.contains('template-collection')){state.collection=location.pathname+location.search;save();}
  window.addEventListener('pagehide',function(){state.scroll={url:location.pathname+location.search,y:scrollY};save();});
  var nav=performance.getEntriesByType('navigation')[0];
  if(nav && nav.type==='back_forward' && state.scroll && state.scroll.url===pageKey){
    // Saved appended pages apply only while Show more is enabled.
    var grid=document.querySelector('.goods'),pages=document.getElementById('loadMore') ? (state.pages[pageKey] || []) : [];
    var initialShown=document.getElementById('lmShown');
    var restoredOffset=grid?Math.max(0,Number(initialShown && initialShown.textContent)-grid.querySelectorAll('.card:not(.promocard):not([data-resurfaced]),.search-content').length):0;
    if(grid)grid.dataset.restoringPages='true';
    (async function(){
      if(grid)for(var path of pages){
        var url=new URL(path,location.origin);if(url.origin!==location.origin)continue;
        try{
          var response=await fetch(url.href);if(!response.ok)break;
          var doc=new DOMParser().parseFromString(await response.text(),'text/html');
          doc.querySelectorAll('.goods .card,.goods .search-content').forEach(function(node){
            var duplicate=node.dataset.productId && Array.from(grid.querySelectorAll('.card[data-product-id]:not([data-resurfaced])')).some(function(c){return c.dataset.productId===node.dataset.productId;});
            if(!duplicate)grid.appendChild(node);
          });
          var current=document.getElementById('loadMore'),fresh=doc.getElementById('loadMore');
          if(current && fresh){var button=current.querySelector('#lmBtn'),next=fresh.querySelector('#lmBtn');if(button){if(next)button.setAttribute('href',next.getAttribute('href'));else button.remove();}var shown=current.querySelector('#lmShown'),freshShown=fresh.querySelector('#lmShown');if(shown && freshShown)shown.textContent=freshShown.textContent;var progress=current.querySelector('#lmBar'),freshProgress=fresh.querySelector('#lmBar');if(progress && freshProgress)progress.style.width=freshProgress.style.width;}
        }catch(e){break;}
      }
      if(grid){
        var restoredCount=restoredOffset+grid.querySelectorAll('.card:not(.promocard):not([data-resurfaced]),.search-content').length;
        var restoredBox=document.getElementById('loadMore'),restoredShown=document.getElementById('lmShown'),restoredBar=document.getElementById('lmBar');
        if(restoredShown)restoredShown.textContent=restoredCount;
        if(restoredBar && restoredBox)restoredBar.style.width=Math.min(100,restoredCount*100/(Number(restoredBox.dataset.total)||1))+'%';
        delete grid.dataset.restoringPages;if(window.wftBindCards)wftBindCards(grid);if(window.wftResurface)wftResurface(grid);document.dispatchEvent(new Event('wft:collection-restored'));}
      requestAnimationFrame(function(){scrollTo(0,state.scroll.y);});
    })();
  }
});

// Recently viewed: local, same-origin product links; capped to six styles.
document.addEventListener('DOMContentLoaded',function(){
  var KEY='wft_recent_products_v1',recent=wftStorage.get(KEY,[]);if(!Array.isArray(recent))recent=[];
  var product=document.querySelector('.pdpsave'),current=product && product.dataset.productId;
  if(product){var image=document.querySelector('.gal .main img');recent=[{id:current,name:product.dataset.name,url:product.dataset.url,img:image?image.src:''}].concat(recent.filter(function(item){return item.id!==current;})).slice(0,7);wftStorage.set(KEY,recent);}
  var items=recent.filter(function(item){return item.id!==current && item.url && new URL(item.url,location.origin).origin===location.origin;}).slice(0,6);
  if(!items.length || !/^(product|collection|search)$/.test(window.WFT.pageType))return;
  var section=document.createElement('section');section.className='recent-products in';var heading=document.createElement('h2');heading.textContent='Recently viewed';section.appendChild(heading);var list=document.createElement('div');list.className='recent-grid';section.appendChild(list);
  items.forEach(function(item){var link=document.createElement('a');link.href=item.url;var image=document.createElement('img');var imageUrl=new URL(item.img,location.origin);imageUrl.searchParams.set('width','400');image.src=imageUrl.href;image.alt='';image.loading='lazy';image.width=200;image.height=267;var name=document.createElement('span');name.textContent=item.name;link.append(image,name);list.appendChild(link);});
  var discover=document.querySelector('[data-discover-more]');
  if(discover) discover.before(section); else document.getElementById('MainContent').appendChild(section);
});

// Export the loaded, available packs as a standalone, printable line sheet.
document.addEventListener('DOMContentLoaded',function(){
  var grid=document.querySelector('.goods');if(!grid || !document.body.classList.contains('template-collection'))return;
  var button=document.createElement('button');button.type='button';button.className='line-sheet-button viewbtn';button.textContent='Line sheet ↓';button.title='Download a line sheet of loaded styles';button.setAttribute('aria-label','Download line sheet of loaded styles');var toolbar=document.querySelector('.viewctl');if(toolbar)toolbar.prepend(button);else grid.before(button);
  button.addEventListener('click',function(){
    if (!window.confirm('Download a line sheet of the currently loaded styles?')) return;
    var rows=[];grid.querySelectorAll('.card[data-product-id]:not([data-resurfaced])').forEach(function(card){card.querySelectorAll('.qarun').forEach(function(run){var url=new URL(card.dataset.url,location.origin);url.searchParams.set('variant',run.dataset.vid);
      var photo=card.querySelector('.pic img, img');
      var source=run.dataset.img || (photo && (photo.currentSrc || photo.src));
      var imageMarkup='';
      if(source){try{var imageUrl=new URL(source,location.origin);if(imageUrl.protocol==='http:' || imageUrl.protocol==='https:'){imageUrl.protocol='https:';imageMarkup='<img src="'+wftEscape(imageUrl.href)+'" width="100" alt="'+wftEscape(card.dataset.name)+'">';}}catch(e){}}
      rows.push('<tr><td>'+imageMarkup+'</td><td><a href="'+wftEscape(url.href)+'">'+wftEscape(card.dataset.name)+'</a></td><td>'+wftEscape(run.dataset.sku)+'</td><td>'+wftEscape(run.dataset.title)+'</td><td>'+wftEscape(run.dataset.pcs)+'</td><td>'+wftMoney(Number(run.dataset.price)*100)+'</td></tr>');});});
    var title=(document.querySelector('h1')||{}).textContent||'Line sheet';
    var html='<!doctype html><html lang="en"><meta charset="utf-8"><meta name="viewport" content="width=device-width"><title>'+wftEscape(title)+'</title><style>body{font:14px Arial;margin:30px;color:#111}table{border-collapse:collapse;width:100%}th,td{border-bottom:1px solid #ddd;text-align:left;padding:12px;vertical-align:middle}img{max-height:130px;object-fit:contain}a{color:inherit}tr{break-inside:avoid}@media print{body{margin:0}}</style><h1>'+wftEscape(title)+'</h1><p>Wholesale Fashion Trends · '+new Date().toLocaleDateString()+' · '+rows.length+' available packs from loaded styles. Prices in '+wftEscape(window.WFT.currency)+'. Prices and availability may change; use product links to order. Print this page to save a PDF.</p><table><thead><tr><th>Image</th><th>Style / ordering link</th><th>SKU</th><th>Color / size run</th><th>Pieces per pack</th><th>Pack price</th></tr></thead><tbody>'+rows.join('')+'</tbody></table></html>';
    var url=URL.createObjectURL(new Blob([html],{type:'text/html'})),a=document.createElement('a');a.href=url;a.download='wft-line-sheet.html';a.click();setTimeout(function(){URL.revokeObjectURL(url);},1000);wftTrack('line_sheet_download',{pack_count:rows.length});
  });
});
(function(){
  document.addEventListener('wft:variant',function(e){var host=document.querySelector('[data-pdp]');if(host && host.dataset.analyticsReady)wftTrack('variant_selected',{variant_id:e.detail.variantId,product_id:host.dataset.productId});if(host)host.dataset.analyticsReady='1';});
  document.addEventListener('click',function(e){var button=e.target.closest('#tBulk');if(button)wftTrack('buying_mode_changed',{buying_mode:button.getAttribute('aria-pressed')==='true'?'bulk':'grid'});});
  var restock=document.getElementById('BackInStock');if(restock)restock.addEventListener('submit',function(){if(restock.checkValidity())wftTrack('restock_request_submitted',{variant_id:(document.getElementById('variantId')||{}).value});});
  document.addEventListener('click',function(e){var a=e.target.closest('a[href^="mailto:"],a[href^="tel:"]');if(a)wftTrack('support_contact',{channel:a.protocol==='tel:'?'phone':'email'});});
})();

// Keep the image-size disclosure keyboard accessible and dismiss it outside the control.
document.addEventListener('click',function(e){var menu=document.getElementById('bulkZoom');if(menu && !menu.contains(e.target))menu.open=false;});
document.addEventListener('keydown',function(e){var menu=document.getElementById('bulkZoom');if(e.key==='Escape' && menu && menu.open){menu.open=false;menu.querySelector('summary').focus();}});

// Scheduled hero slides and campaign banners. Liquid picks what is live when the page is
// rendered; this re-checks in the browser so a page Shopify served from cache never shows
// an expired promotion. Must run before the hero slider counts its slides.
// Preview a moment in store time with ?promo_preview=2026-11-27T10:00
(function () {
  var STORE_TIME_ZONE = 'America/Los_Angeles';
  function zoneOffset(ms) {
    var p = {};
    new Intl.DateTimeFormat('en-US', {timeZone: STORE_TIME_ZONE, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'})
      .formatToParts(new Date(ms)).forEach(function (part) { p[part.type] = part.value; });
    return Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second) - ms;
  }
  function previewTime() {
    var raw = new URLSearchParams(location.search).get('promo_preview');
    var m = raw && raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    var wall = Date.UTC(+m[1], +m[2] - 1, +m[3], +(m[4] || 0), +(m[5] || 0));
    var ms = wall - zoneOffset(wall);
    return (wall - zoneOffset(ms)) / 1000;
  }
  function isLive(el, now) {
    if (el.hasAttribute('data-promo-off')) return false;
    var start = Number(el.dataset.start) || 0, end = Number(el.dataset.end) || 0;
    return (!start || now >= start) && (!end || now < end);
  }
  function keepOnly(items, keep) {
    items.forEach(function (el) { if (keep.indexOf(el) < 0) el.remove(); else el.hidden = false; });
  }
  function applyHero(slider, now) {
    var all = Array.from(slider.querySelectorAll('.hero-slides > [data-promo]'));
    if (!all.length) return;
    function role(name) { return all.filter(function (el) { return el.dataset.promo === name; }); }
    var live = role('primary').filter(function (el) { return isLive(el, now); });
    var keep = live.length ? live : role('fallback').length ? role('fallback') : role('default');
    if (!keep.length) return;
    keepOnly(all, keep);
    keep.forEach(function (el, i) { if (el.hasAttribute('aria-roledescription')) el.setAttribute('aria-label', (i + 1) + ' of ' + keep.length); });
    var hero = slider.closest('.hero');
    var copy = hero && hero.querySelector('.copy');
    if (!copy) return;
    var winner = keep.find(function (el) { return el.querySelector(':scope > template[data-hero-copy]'); });
    var source = winner ? winner.dataset.slideId : 'default';
    if (copy.dataset.copySource === source) return;
    var template = winner ? winner.querySelector(':scope > template[data-hero-copy]') : hero.querySelector('template[data-hero-copy-default]');
    if (!template) return;
    copy.innerHTML = template.innerHTML;
    copy.dataset.copySource = source;
  }
  function applyCampaign(grid, now) {
    var items = Array.from(grid.querySelectorAll(':scope > [data-promo]'));
    if (!items.length) return;
    var anyLive = items.some(function (el) { return el.dataset.promo === 'primary' && isLive(el, now); });
    var keep = [], slots = {};
    items.forEach(function (el) {
      var slot = el.dataset.slot || 'none';
      if (slot !== 'none') { (slots[slot] = slots[slot] || []).push(el); return; }
      if (el.dataset.promo === 'primary' ? isLive(el, now) : !anyLive) keep.push(el);
    });
    Object.keys(slots).forEach(function (slot) {
      var group = slots[slot];
      var winner = group.find(function (el) { return el.dataset.promo === 'primary' && isLive(el, now); }) ||
        group.find(function (el) { return el.dataset.promo === 'fallback'; });
      if (winner) keep.push(winner);
    });
    keepOnly(items, keep);
  }
  function applySchedules() {
    if (window.Shopify && window.Shopify.designMode) return;
    var preview = previewTime();
    var now = preview || Date.now() / 1000;
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) { applyHero(slider, now); });
    document.querySelectorAll('.campaign').forEach(function (grid) { applyCampaign(grid, now); });
    // Promotion chips and product-page strips. Liquid prints an upcoming
    // promotion hidden and a live one visible; on a page served from cache
    // either can be wrong by the time it is read, so re-check both ways here.
    document.querySelectorAll('[data-promo-badge]').forEach(function (el) {
      if (isLive(el, now)) el.hidden = false; else el.remove();
    });
    if (preview) {
      var note = document.createElement('p');
      note.className = 'promo-preview-note';
      note.setAttribute('role', 'status');
      note.textContent = 'Previewing scheduled slides and banners as of ' + new Date(preview * 1000).toLocaleString('en-US', {timeZone: STORE_TIME_ZONE, dateStyle: 'medium', timeStyle: 'short'}) + ' store time';
      document.body.appendChild(note);
    }
  }
  document.addEventListener('DOMContentLoaded', applySchedules);
})();

// Hero image slides: touch scrolling, keyboard controls, and theme editor selection.
(function () {
  function initHeroSliders() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      var track = slider.querySelector('.hero-slides');
      var slides = Array.from(track.children);
      var controls = slider.querySelector('.hero-slider-controls');
      if (!controls) return;
      controls.hidden = false;
      var current = 0;
      var hero = slider.closest('.hero');
      var copy = hero && hero.querySelector('.copy');
      var mobile = matchMedia('(max-width:860px)');
      var reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      var timer, paused = false, hovered = false, focused = false, inView = false;
      var pauseButton = controls.querySelector('[data-slide-pause]');
      var delay = Math.max(3, Math.min(15, Number(slider.dataset.autoplayDelay) || 5)) * 1000;
      function autoplayEnabled() {
        return slider.dataset[mobile.matches ? 'autoplayMobile' : 'autoplayDesktop'] === 'true' && slides.length > 1 && !reducedMotion.matches;
      }
      function schedule() {
        clearTimeout(timer);
        var enabled = autoplayEnabled();
        if (pauseButton) {
          pauseButton.hidden = !enabled;
          pauseButton.textContent = paused ? '▶' : 'Ⅱ';
          pauseButton.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        }
        controls.querySelector('[data-slide-count]').setAttribute('aria-live', enabled && !paused ? 'off' : 'polite');
        if (enabled && !paused && !hovered && !focused && inView && !document.hidden) timer = setTimeout(function () { go(current + 1); schedule(); }, delay);
      }
      function manualGo(index) { go(index); schedule(); }
      if (pauseButton) pauseButton.addEventListener('click', function () { paused = !paused; schedule(); });
      slider.addEventListener('mouseenter', function () { hovered = true; schedule(); });
      slider.addEventListener('mouseleave', function () { hovered = false; schedule(); });
      slider.addEventListener('focusin', function () { focused = true; schedule(); });
      slider.addEventListener('focusout', function (e) { focused = slider.contains(e.relatedTarget); schedule(); });
      track.addEventListener('pointerdown', function () { clearTimeout(timer); });
      track.addEventListener('pointerup', schedule);
      track.addEventListener('pointercancel', schedule);
      function visibilityChanged() { schedule(); }
      document.addEventListener('visibilitychange', visibilityChanged);
      reducedMotion.addEventListener('change', schedule);
      var visibilityObserver = new IntersectionObserver(function(entries){inView=entries[0].isIntersecting;schedule();});
      visibilityObserver.observe(slider);
      function layout() {
        var textSlide = slider.dataset.mobileTextSlide === 'true' && mobile.matches && copy;
        if (textSlide) {
          copy.classList.add('hero-slide');
          track.prepend(copy);
          hero.classList.add('hero--text-slider');
        } else if (copy && copy.parentNode === track) {
          hero.insertBefore(copy, slider);
          copy.classList.remove('hero-slide');
          copy.querySelectorAll('a').forEach(function(link){link.removeAttribute('tabindex');});
          hero.classList.remove('hero--text-slider');
        }
        slides = Array.from(track.children);
        controls.hidden = slides.length < 2;
        track.tabIndex = slides.length > 1 ? 0 : -1;
        track.setAttribute('aria-label', textSlide ? 'Hero slides; use arrow keys to browse' : 'Featured images; use arrow keys to browse');
        slider.setAttribute('role', 'region');
        slider.setAttribute('aria-label', textSlide ? 'Featured content' : 'Featured images');
        slider.setAttribute('aria-roledescription', 'carousel');
        track.scrollTo({left:0,behavior:'instant'});
        paint();
        schedule();
      }
      function paint() {
        current = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));
        controls.querySelector('[data-slide-count]').textContent = (current + 1) + ' / ' + slides.length;
        slides.forEach(function (slide, i) { slide.querySelectorAll('a').forEach(function(link){link.tabIndex = i === current ? 0 : -1;}); });
        slider.classList.toggle('showing-text-slide', slides[current] === copy);
      }
      function go(index, instant) {
        index = (index + slides.length) % slides.length;
        track.scrollTo({left: index * track.clientWidth, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }
      controls.querySelector('[data-slide-prev]').addEventListener('click', function () { manualGo(current - 1); });
      controls.querySelector('[data-slide-next]').addEventListener('click', function () { manualGo(current + 1); });
      track.addEventListener('scroll', paint, {passive: true});
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); manualGo(current + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      slider.addEventListener('shopify:block:select', function (e) {
        var index = slides.findIndex(function (slide) { return slide.dataset.slideId === e.detail.blockId; });
        if (index >= 0) { paused = true; go(index, true); schedule(); }
      });
      mobile.addEventListener('change', layout);
      var section = slider.closest('.shopify-section');
      function cleanup(e) { if(section && e.target === section){clearTimeout(timer);visibilityObserver.disconnect();reducedMotion.removeEventListener('change',schedule);document.removeEventListener('visibilitychange',visibilityChanged);mobile.removeEventListener('change',layout);document.removeEventListener('shopify:section:unload',cleanup);} }
      document.addEventListener('shopify:section:unload', cleanup);
      layout();
    });
  }
  document.addEventListener('DOMContentLoaded', initHeroSliders);
  document.addEventListener('shopify:section:load', initHeroSliders);
})();

// Mobile search shares the header's existing search form and predictive results.
(function () {
  document.querySelectorAll('.mobile-search-toggle').forEach(function (button) {
    var form = document.getElementById(button.getAttribute('aria-controls'));
    if (!form) return;
    var header = button.closest('.hdr');
    header.classList.add('has-mobile-search');
    button.hidden = false;
    function setOpen(open, restoreFocus) {
      header.classList.toggle('search-open', open);
      button.setAttribute('aria-expanded', String(open));
      if (open) form.querySelector('[type="search"]').focus();
      else if (restoreFocus) button.focus();
    }
    button.addEventListener('click', function () {
      setOpen(button.getAttribute('aria-expanded') !== 'true', false);
    });
    form.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && window.matchMedia('(max-width:900px)').matches) setOpen(false, true);
    });
  });
})();

// Load decorative alternate card photos only when a hover-capable buyer asks.
(function () {
  function reveal(event) {
    if (!matchMedia('(hover:hover)').matches) return;
    var card = event.target.closest && event.target.closest('.card');
    var figure = card && card.querySelector('figure');
    var image = figure && figure.querySelector('img.alt[data-src]');
    if (!image || image.hidden) return;
    image.sizes = Math.ceil(figure.getBoundingClientRect().width) + 'px';
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    image.removeAttribute('data-src'); image.removeAttribute('data-srcset');
    image.dataset.hoverLoaded = 'true';
  }
  document.addEventListener('pointerover', reveal, {passive:true});
  document.addEventListener('focusin', reveal);
})();

// A single short scroll hint yields immediately to buyer interaction.
(function () {
  function bind() {
    document.querySelectorAll('nav.cats').forEach(function (nav) {
      var links = nav.querySelector('.category-links');
      if (!links || links.dataset.swipeBound) return;
      links.dataset.swipeBound = 'true';
      var frame, stopped = false;
      function update() { nav.classList.toggle('has-more', matchMedia('(max-width:900px)').matches && links.scrollWidth - links.clientWidth - links.scrollLeft > 2); }
      function stop() { stopped = true; cancelAnimationFrame(frame); }
      ['pointerdown','touchstart','keydown','focusin','wheel'].forEach(function (name) { links.addEventListener(name, stop, {passive:true}); });
      links.addEventListener('scroll', update, {passive:true});
      new ResizeObserver(update).observe(links); update();
      setTimeout(function () {
        update();
        if (stopped || !nav.classList.contains('has-more') || links.scrollLeft > 0 || matchMedia('(prefers-reduced-motion:reduce)').matches) return;
        var start;
        function tick(time) {
          if (stopped || !links.isConnected) return;
          if (!start) start = time;
          var progress = Math.min(1,(time-start)/800);
          links.scrollLeft = Math.sin(progress*Math.PI)*24;
          if (progress < 1) frame = requestAnimationFrame(tick); else update();
        }
        frame = requestAnimationFrame(tick);
      }, 600);
    });
  }
  bind(); document.addEventListener('shopify:section:load',bind);
})();
